<template>
  <div class="profile">
    <el-card>
      <section class="panel">
        <div class="divider">
          <h3>{{$t('messages.profile.profile1')}}</h3>
        </div>
        <el-form
          ref="profile"
          :model="contact"
          :rules="rules"
          label-position="right"
          label-width="120px"
        >
          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item :label="$t('messages.register.name')" prop="username">
                <el-input v-model="contact.username"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile2')">
                <el-input v-model="contact.invoice_name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item :label="$t('messages.login.email')">
                <el-input v-model="contact.email" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile7')">
                <el-input v-model="contact.whatsapp"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile3')">
                <el-input v-model="contact.skype"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile6')">
                <el-input v-model="contact.telegram"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="80">
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile5')">
                <el-input v-model="contact.wechat"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('messages.login.phone')">
                <el-input v-model="contact.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item :label="$t('messages.profile.profile4')">
                <el-input v-model="contact.address"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="saveContact">{{ $t('messages.profile.profile12') }}</el-button>
          </el-row>
        </el-form>
      </section>
    </el-card>
    <el-card>
      <section class="panel">
        <div class="divider"><h3>{{$t('messages.profile.profile8')}}</h3></div>
        <el-form
          ref="password"
          :model="password"
          :rules="passwordRules"
          label-position="right"
          label-width="180px"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile9')" prop="origin_password">
                <el-input type="password" v-model="password.origin_password"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile10')" prop="password">
                <el-input type="password" v-model="password.password"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('messages.profile.profile11')" prop="confirm_password">
                <el-input type="password" v-model="password.confirm_password"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="savePassword">{{ $t('messages.profile.profile12') }}</el-button>
          </el-row>
        </el-form>
      </section>
    </el-card>
  </div>
</template>

<script>
import { throttleFn } from '@/js/common'
export default {
  data() {
    return {
      contact: {
        username: '',
        invoice_name: '',
        email: '',
        whatsapp: '',
        skype: '',
        telegram: '',
        wechat: '',
        phone: '',
        address: '',
      },
      password: {
        origin_password: '',
        password: '',
        confirm_password: '',
      },
      rules: {
        username: [
          this.createRequiredRule(this,'messages.tipError.emptyErr')
        ],
      },
      passwordRules: {
        origin_password: [
          this.createRequiredRule(this,'messages.tipError.emptyErr')
        ],
        password: [
          this.createRequiredRule(this,'messages.tipError.emptyErr')
        ],
        confirm_password: [
          this.createRequiredRule(this,'messages.tipError.emptyErr')
        ],
      },
    }
  },
  created() {
    this.getProfile()
  },
  methods: {
    getProfile() {
      this.$http
        .get('/api/accounts/profile/')
        .then(data => {
          this.contact = data
          this.$store.commit('PROFILE', data)
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    },
    saveContactPost: throttleFn(function() {
      this.$http
        .post('/api/accounts/profile/', this.contact)
        .then(res => {
          this.notifyOpen(this.$t('messages.createCampaign.create203'))
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    }, 3000),
    saveContact() {
      this.$refs.profile.validate(valid => {
        if (valid) {
          this.saveContactPost()
        }
      })
    },
    savePasswordPost: throttleFn(function() {
      this.$http
        .post('/api/accounts/modify-pwd/', this.password)
        .then(res => {
          this.notifyOpen(this.$t('messages.createCampaign.create203'))
        })
        .catch(error => {
          this.notifyOpen('Error', this.executeError(error), 'error')
        })
    }, 3000),
    savePassword() {
      this.$refs.password.validate(valid => {
        if (valid) {
          this.savePasswordPost()
        }
      })
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.refreshFormValidateOnLocaleChange(this, ['profile', 'password'])
      }
    },
  },
}
</script>

<style lang="scss">
.profile {
  .el-card {
    margin-bottom: 24px;
    .el-card__body {
      padding-bottom: 50px;
      padding-top: 0;
    }
  }
}
</style>
